/**
 * External dependencies.
 */
import classNames from "classnames";
import Link from "next/link";
import { localizedLinkProps, linkRel } from "lib/navigation";
import { useRouter } from "next/router";

interface LinkWithOptionsProp {
  data: {
    URL: string;
    Text: string;
    OpenInNewTab: boolean;
    RelNoFollow: boolean;
  };
  className?: string;
  children?: any;
  onClick?: any;
}

const LinkWithOptions: React.FC<LinkWithOptionsProp> = ({
  data,
  className,
  children,
  onClick,
}) => {
  const { locale, pathname } = useRouter();
  if (!data || !data.URL || !data.Text) {
    return <></>;
  }
  const linkProps = localizedLinkProps(data.URL, locale);

  return (
    <Link
      {...linkProps}
      className={classNames(className, {
        "is-active": pathname === data.URL,
      })}
      target={data.OpenInNewTab ? "_blank" : "_self"}
      rel={linkRel(data.RelNoFollow, data.OpenInNewTab)}
      title={data.Text}
      onClick={onClick}
    >
      {children ? children : data.Text}
    </Link>
  );
};

export default LinkWithOptions;
